import { t } from '@base/utils/helpers';
import React from 'react';
import { Price } from '../model/interfaces';

export default function PriceSelect(props: {
  prices: Price[];
  price?: string;
  setPrice: (price: string) => void;
}) {
  return (
    <select
      name="amount"
      id="amount"
      onChange={(e) => props.setPrice(e.target.value)}
      value={props.price}
    >
      {props.prices.map((price) => (
        <option value={price.price} key={price.description}>
          {price.tickets} $T {t('total_price')}: ${price.price}
        </option>
      ))}
    </select>
  );
}
